module.exports = __webpack_public_path__ + "img/twitter.1ac19cc1.png";